import { isObject } from 'radash';

export type HasKind<K extends string> = {
  readonly kind: K;
};

export type KindOf<T> = T extends HasKind<infer K> ? K : never;
export type TypeForKind<T, K extends string> = Extract<T, HasKind<K>>;

// `any` here lets us extract the specific K and require that it matches
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isHasKind<T extends HasKind<any>>(kind: KindOf<T>, obj: unknown): obj is T {
  if (!isObject(obj)) return false;
  const possible = obj as Partial<HasKind<string>>;
  return kind === possible.kind;
}
